exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".toast___Qjbt{padding:8px;color:#fff;-webkit-box-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -2px rgba(0,0,0,.05);box-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -2px rgba(0,0,0,.05);border-radius:4px;background-color:#212121;width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/Toast/Toast.styles.scss"],"names":[],"mappings":"AAEA,cACE,YACA,WACA,kFAAA,0EACA,kBACA,yBACA,UAAW,CACZ","file":"Toast.styles.scss","sourcesContent":["@import '../../variables';\n\n.toast {\n  padding: 8px;\n  color: #fff;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  background-color: $gray-900;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toast": "toast___Qjbt"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/Toast/Toast.styles.scss
// module id = J9ZU
// module chunks = 0